export default __webpack_public_path__ + "static/media/amanita3.167a9acb.png";